module.exports = __webpack_public_path__ + "37205cb0726528e43fff2808515b8666.mp4";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/video/trailer-teaser-1080.mp4
// module id = 656
// module chunks = 0